import { discountedPriceDisplay, priceDisplay } from "helpers/price";
import moment from "moment-timezone";
import React, { Component } from "react";
import { Button, Rating } from "semantic-ui-react";
import done from '../../assets/images/newui/done.svg';

class DealsModalBidSection extends Component {
    constructor(props) {
        super(props)
    }

    getDiscountedPrice = (bid) => {
        return discountedPriceDisplay(bid.sellerBid.price, this.props.request.discountPercent, this.props.request.discountAmount);
     }

    render() {
        return <div className='deals-modal-bid-details '>
            {this.props.bids ? this.props.bids.map(bid => <div className='deals-modal-bid-section' style={!_.isEmpty(bid.sellerBid.acceptedOn) ? {display: 'flex', alignItems: 'center', justifyContent: 'space-between'} : {}}><div className="deals-modal-seller-details">
                <div className="deals-modal-bidder-name deals-bidder-name">{bid.seller.name}</div>
                <div className="deals-modal-bidder-rating deals-bidder-rating"><Rating disabled icon='star' defaultRating={bid.seller.rating} maxRating={5} /></div>
                <div className="deals-modal-bidder-time deals-bidder-time">{moment(bid.sellerBid.bidOn).format('hh:mma MM/DD/YYYY')}</div>
                <div className="deals-modal-bid-price deals-bid-price">{this.props.request.discountPercent || this.props.request.discountAmount != "0" ? this.getDiscountedPrice(bid) : '$' + bid.sellerBid.price.toFixed(2)}</div>
                {
                    (this.props.request.discountPercent || this.props.request.discountAmount != "0") && 
                    <div className="deals-modal-bid-price deals-bid-price-original">{priceDisplay(bid.sellerBid.price)}</div>
                }
            </div>
                {!this.props.request.isAccepted  &&
                <Button onClick={() => this.props.onBidAcceptance(bid)}>
                    Book Service
                    </Button>
                }   
                {!_.isEmpty(bid.sellerBid.acceptedOn) && <div className="accepted-tag" style={{alignSelf: 'flex-end', marginBottom: '10px'}}>
                <div><img src={done}></img></div>
                <div>Accepted</div>
                </div>
                }
                    {_.isEmpty(bid.sellerBid.acceptedOn) && bid.sellerBid.sellerAvailability && bid.sellerBid.sellerAvailability.map((availability) => {
                    return <div className="deals-modal-bid-details-availability">
                        <div className="heading">Earliest Appointment</div>
                        <div className="date">
                            <div>
                                <div>{moment.tz(availability, this.props.timezone).format('DD MMM YYYY')}</div>
                                <div>{moment.tz(availability, this.props.timezone).format('hh:mm A')}</div>
                            </div>
                        </div>
                    </div>
                })
                }
                    
            </div>) : ''}
        </div>
    }
}

export default DealsModalBidSection;